import Link from "../link";
import style from "./style.scss";
import namedRoutes from "../../settings/routes";

const Header = () => (
  <header class={style.header}>
    <div class={style.navigation}>
      <nav>
        <ul>
          <li>
            <Link activeClassName={style.current} href={namedRoutes.home}>
              Home
            </Link>
          </li>
          <li>
            <Link activeClassName={style.current} href={namedRoutes.connieWan}>
              <span class={style.full}>Connie Wan</span>
              <span class={style.short}>Connie W.</span>
            </Link>
          </li>
          <li>
            <Link
              activeClassName={style.current}
              href={namedRoutes.johnPerkins}
            >
              <span class={style.full}>John Perkins</span>
              <span class={style.short}>John P.</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
);

export default Header;
